import React, { memo, useState } from 'react';
import { PERMISSIONS } from 'constants/permissions';
import { ValidationErrors } from 'constants/validations';
import { AddClient } from 'pages/admin/clients/addClient';
import { useLeadDetailsEdit } from './useLeadDetailsEdit';
import { ClientSelect } from 'components/common/clientSelect';
import { Col, Form, FormModal, Input, Row, Select } from 'components';
import { ContactPersonAddEdit } from 'components/common/contactPerson/addEdit';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';

export interface ILeadDetailsUpdate {
  onCancel: () => void;
  open?: boolean;
}

export const LeadEditModal = memo<ILeadDetailsUpdate>((props) => {
  const [form] = Form.useForm();
  const { hasAccess } = useAccessControl();
  const [openContactPersonModal, setOpenContactPersonModal] = useState(false);
  const { onCancel, open } = props;

  const {
    onFinish,
    isSaveBtnDisabled,
    checkErrors,
    onCancelModal,
    isLoading,
    sourceTypes,
    openClientModal,
    setOpenClientModal,
    contactPersons,
    selectedClient,
    isLoadingContactPerson,
  } = useLeadDetailsEdit({
    onCancel,
    form,
    open,
  });

  return (
    <>
      <FormModal
        form={form}
        width={680}
        title={'Update Lead Details'}
        okText={'Save'}
        open={open}
        isLoading={isLoading}
        disableOkBtn={isSaveBtnDisabled}
        onValuesChange={checkErrors}
        onCancel={onCancelModal}
        onSubmit={onFinish}
      >
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item
              label="Client Name*"
              name="clientId"
              rules={[{ required: true, message: ValidationErrors.required('Client') }]}
            >
              <ClientSelect
                showAdd={hasAccess(PERMISSIONS.clients.client.write)}
                onAdd={() => setOpenClientModal(true)}
                size="large"
                onChange={() => {
                  form.setFieldsValue({ contactPersonId: undefined });
                }}
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Contact Person*"
              name="contactPersonId"
              rules={[{ required: true, message: ValidationErrors.required('Contact Person') }]}
            >
              <Select
                size={'large'}
                loading={isLoadingContactPerson}
                onAdd={() => setOpenContactPersonModal(true)}
                showAdd={hasAccess(PERMISSIONS.clients.contact_person.write)}
                disabled={!selectedClient}
                options={contactPersons}
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name="clientRequestNumber"
              label="Client Request Number*"
              rules={[{ required: true, message: ValidationErrors.required('Client Request Number') }]}
            >
              <Input size="large" placeholder="Enter client request number" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name="source"
              label="Source*"
              rules={[{ required: true, message: ValidationErrors.required('Source') }]}
            >
              <Select size="large" options={sourceTypes} />
            </Form.Item>
          </Col>
        </Row>
      </FormModal>
      <AddClient modalState={openClientModal} closeModal={() => setOpenClientModal((os) => !os)} />
      <ContactPersonAddEdit
        entityName={'CLIENT'}
        modalState={openContactPersonModal}
        clientId={selectedClient}
        onModalStateChange={() => setOpenContactPersonModal((oState) => !oState)}
      />
    </>
  );
});
